"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_LANGUAGE = "_internal_lang";
